import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
// custom imports
import inspectionService from '../../../Services/inspectionService/inspectionService';
import showToast from '../../../Utils/Toast/ToastNotification';
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError.js'
import { hideLoader, showLoader } from '../../../Redux/Slice/Loader/loaderSlice';
// css
import './Inspectiondetails.css'

const Inspectiondetail = () => {

    const dateInputRef = useRef(null);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()
    const [inspection, setInspection] = useState(null)
    const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token)

    const handleFocus = () => {
        if (dateInputRef.current) {
            dateInputRef.current.showPicker?.();
        }
    };

    // get inspection details by their id
    const getInspection = async () => {
        dispatch(showLoader());
        try {
            const response = await inspectionService.getInspection(id, token)
            if (response?.data?.statusCode === 200) {
                setInspection(response?.data?.body?.data?.inspection[0])
            } else {
                showToast("error", response?.data?.body?.message)
            }

        } catch (error) {
            await HandleApiError(error)
        } finally {
            dispatch(hideLoader())
        }
    }

    useEffect(() => {
        getInspection()
    }, [id])

    if (!inspection) {
        return null;
    }
    return (
        <>
            <div className='main-inner-block'>
                <div className='heading-content'>
                    Inspection Details
                </div>
                <div className='content'>
                    <div className='white-box'>
                        <form>
                            <div class="create-user-block">
                                <div className='profile-box-area inspection-blk d-flex flex-wrap align-items-center'>

                                    <div className='profile-box inspectiondetails'>
                                        <label for="inspection-name" class="form-label m-0">Inspection Name</label>
                                        <div className='form-input-block'>
                                            {inspection.inspection_name}
                                        </div>
                                    </div>
                                    <div className='profile-box inspectiondetails'>
                                        <label for="ProjectAddress" class="form-label m-0">Project Address</label>
                                        <div className='form-input-block'> {inspection.project_streetaddress} {inspection.porject_suburb}{" "}
                                            {inspection.state_name} {inspection.project_postCode}</div>
                                    </div>

                                    <div className='profile-box inspectiondetails'>
                                        <label for="inspector" class="form-label m-0">Inspector</label>
                                        <div className='form-input-block'>{inspection.inspectors.length > 0
                                            ? inspection.inspectors
                                                .map((inspectors) =>
                                                    inspectors?.first_name || inspectors?.last_name
                                                        ? `${inspectors.first_name || ""} ${inspectors.last_name || ""}`.trim()
                                                        : null
                                                )
                                                .filter(Boolean)
                                                .join(", ")
                                            : "No Inspectors"
                                        }</div>
                                    </div>
                                    <div className='profile-box inspectiondetails'>
                                        <label for="Inspectiontemplate" class="form-label m-0">Inspection Template</label>
                                        <div className='form-input-block'>{inspection.template_name}</div>
                                    </div>

                                    <div className='profile-box inspectiondetails'>
                                        <label for="inspection-name" class="form-label m-0">Inspection Date</label>
                                        <div className='form-input-block'>
                                            {inspection.inspection_date
                                                ? new Date(inspection.inspection_date).toLocaleDateString()
                                                : "-"}
                                        </div>
                                    </div>

                                    <div className='profile-box inspectiondetails'>
                                        <label for="Inspectiontemplate" class="form-label m-0">Status</label>
                                        <div className='form-input-block'>{inspection.status}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center d-flex justify-content-center button-block gap-3 mt-5">
                                <button
                                    type="submit"
                                    class="green-btn submit-btn view-btn"
                                    onClick={() => navigate("/inspection-listing")}
                                >
                                    Back
                                </button>

                                <button
                                    type="submit"
                                    class="green-btn submit-btn view-btn"
                                    onClick={() => navigate(`/update-inspection/${id}`)}
                                >
                                    Edit Details
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>



        </>
    )
}

export default Inspectiondetail